<template>
  <v-row no-gutters class="fill-height">
    <v-col class="d-flex flex-column align-stretch">
      <v-row style="max-height: 40px;" no-gutters>
        <v-col>
          <theHeading ref="theHeading">
            <template v-slot:tools>
              <go-back :text="'Resum planificacions'" />
            </template>
          </theHeading>
        </v-col>
      </v-row>
      <kanban-judo
        :service="service"
        :showChildren="showChildren"
        :showMedia="showMedia"
        :customFunctions="customFunctions"
        @setHeading="setHeading"
      />
    </v-col>
  </v-row>
</template>

<script>
import ServiceFactory from "@/services/ServiceFactory"

export default {
  components: {
    KanbanJudo: () => import("@/components/judo/KanbanJudo"),
    goBack: () => import("@/components/BackButton"),
    theHeading: () => import("@/layouts/intranet/components/viewHeading"),
  },
  data() {
    return {
      service: ServiceFactory.get("planificacions"),
      showChildren: false,
      showMedia: false,
      customFunctions: {
        downloadPdf(mesocicle_id) {
          const MesocicleService = ServiceFactory.get("mesocicles")
          MesocicleService.getPdf(mesocicle_id).then(response => {
            const link = document.createElement("a")
            link.href =
              "data:application/octet-stream;base64," + response.data.binary
            link.download = response.data.filename + ".pdf"
            link.dispatchEvent(new MouseEvent("click"))
          })
        },
      },
    }
  },
  methods: {
    setHeading(name) {
      this.$refs.theHeading.heading = name
    },
  },
}
</script>

<style lang="scss" scoped></style>
